/**
 * Public paznetworks.com pages for PazNetworks solutions. A solution chip in
 * the portals links here so a customer can read more. Only pages that exist
 * are listed (checked 2026-09-21); add a slug when a marketing page ships.
 */
export const SOLUTION_LINKS: Readonly<Record<string, string>> = {
  managed_network: 'https://www.paznetworks.com/solutions/managed-network-solutions',
  video_surveillance: 'https://www.paznetworks.com/solutions/surveillance-solutions',
  conferencing: 'https://www.paznetworks.com/solutions/conferencing-solutions',
  audio: 'https://www.paznetworks.com/solutions/audio-solutions',
  smart_robotics: 'https://www.paznetworks.com/solutions/smart-robotics-solutions',
  keytracer: 'https://www.paznetworks.com/solutions/security-solutions',
  pos_systems: 'https://www.paznetworks.com/solutions/retail-solutions',
  digital_signage: 'https://www.paznetworks.com/solutions/digital-signage',
};

export function solutionLink(solutionType: string): string | null {
  return SOLUTION_LINKS[solutionType] ?? null;
}
